import PopUpView from './popUpView';

export * from './popUpView';

export default PopUpView;
